import "./blog.scss"
import initRecipeRating from "./recipe_rating"

onReady(() => {
  initRecipeRating()
  new Swiper(".swiper-container", {
    spaceBetween: 100,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
    },
  })
})

$("document").ready(function () {
  const iconContentImg = $(".icon-content img")
  /**
   * BLog - filter kategórii - mobilné zobrazenie
   */
  $(".blog-filter-button").on("click", function (e) {
    e.preventDefault()

    if ($(this).hasClass("is-toogle-on")) {
      // filter je otvorený, skrývam ho
      const filter_filter = iconContentImg.attr("data-toogle-icon")
      const filter_close = iconContentImg.attr("src")

      $(this).removeClass("is-toogle-on")
      $(".blog-filter-content").hide()
      iconContentImg.attr("src", filter_filter)
      iconContentImg.attr("data-toogle-icon", filter_close)
    } else {
      // filter je skrytý, odkrývam ho
      const filter_close = iconContentImg.attr("data-toogle-icon")
      const filter_filter = iconContentImg.attr("src")

      $(this).addClass("is-toogle-on")
      $(".blog-filter-content").fadeIn()
      iconContentImg.attr("src", filter_close)
      iconContentImg.attr("data-toogle-icon", filter_filter)
    }
  })
  $(".mobile-menu-subcategory-href").hide()

  const first_parent_id = $(".mobile-menu-category-href:first-child").attr(
    "data-show"
  )
  $(".mobile-menu-subcategory-href-" + first_parent_id).show()

  $(".mobile-menu-category-href").on("click", function () {
    $(".mobile-menu-category-href").css("background-color", "#ffffff")
    $(this).css("background-color", "#ededed")

    $(".mobile-menu-subcategory-href").hide()
    $(".mobile-menu-subcategory-href-" + $(this).attr("data-show")).show()
  })

  /**
   * Smooth scroll na nadpis v článku.
   */
  $(".blog-toc-a").on("click", function (e) {
    e.preventDefault()
    const navHeight = $(window).width() < 768 ? 0 : $(".navbar-fixed-top").height()
    $.scrollTo($(this).attr("href"), 300, { offset: -1 * navHeight - 15 })
  })
})
